import { render, staticRenderFns } from "./form-custom-audiences.vue?vue&type=template&id=101aae67&scoped=true&"
import script from "./form-custom-audiences.vue?vue&type=script&lang=js&"
export * from "./form-custom-audiences.vue?vue&type=script&lang=js&"
import style0 from "./form-custom-audiences.vue?vue&type=style&index=0&id=101aae67&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101aae67",
  null
  
)

export default component.exports